module.exports = __webpack_public_path__ + "static/media/pra-hot-comment.920d6e97.png";